import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  container: {
    marginBottom: '20px',
    minWidth: '225px',
  },
  outerContainer: {
    marginRight: '120px',
  },
  header: {
    cursor: 'pointer',
  },
  checkboxContainer: {
    marginTop: '16px',
  },
  sublistChevron: {
    cursor: 'pointer',
  },
  sublistChevronHidden: {
    visibility: 'hidden',
  },
  highlightedText: {
    backgroundColor: 'rgba(243, 211, 113, 0.62)',
  },
  checkboxWrapper: {
    marginBottom: '8px',
  },
  onlyOfficeAddressContainer: {
    display: 'flex',
    marginTop: '5px',
    marginBottom: '20px',
  },
  onlyOfficeAddressText: {
    marginLeft: '8px',
    fontSize: '14px',
    fontWeight: 400,
  },
  collapseArrow: {
    zIndex: '1',
  },
  onlyOfficeAddressTooltip: {
    position: 'relative',
    top: '-1.5px',
    marginLeft: '2px',
    transform: 'scale(0.7)',
  },
}));
